/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
// Component
import MediaEmbed from '@components/Embeds/MediaEmbed';

/* Services */
// import { consoleLog } from '@components/Utility/Shared/SharedService';

/**
 *
 * @param {Object} param0
 * @returns
 */
const Video = ({ sectionContent, region, lang }) => {
  return (
    <Box width={'100%'}>
      <Box px={{ md: '270px', base: '0' }} marginTop="90px">
        <MediaEmbed sectionContent={sectionContent[0]} />
      </Box>
    </Box>
  );
};

export default Video;
